"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/styles");

var _react = _interopRequireDefault(require("react"));

var _constants = require("../../constants");

var _hooks = require("../../hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AccessDenied = function AccessDenied(_ref) {
  var style = _ref.style,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? _constants.EN_LOCALE : _ref$locale;
  var theme = (0, _styles.useTheme)();
  var imgSrc = '';

  switch ("".concat(locale, "|").concat(theme.palette.mode)) {
    case "".concat(_constants.JA_LOCALE, "|").concat(_constants.DARK_MODE):
      imgSrc = _constants.ACCESS_DENIED_JA_DARK;
      break;

    case "".concat(_constants.EN_LOCALE, "|").concat(_constants.DARK_MODE):
      imgSrc = _constants.ACCESS_DENIED_EN_DARK;
      break;

    case "".concat(_constants.JA_LOCALE, "|").concat(_constants.LIGHT_MODE):
      imgSrc = _constants.ACCESS_DENIED_JA_LIGHT;
      break;

    case "".concat(_constants.EN_LOCALE, "|").concat(_constants.LIGHT_MODE):
      imgSrc = _constants.ACCESS_DENIED_EN_LIGHT;
      break;

    default:
      imgSrc = _constants.ACCESS_DENIED_EN_LIGHT;
  }

  var _useThemeModeImage = (0, _hooks.useThemeModeImage)(_constants.ACCESS_DENIED_EN, imgSrc),
      _useThemeModeImage2 = _slicedToArray(_useThemeModeImage, 1),
      src = _useThemeModeImage2[0];

  return /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    "aria-label": "access-denied-img",
    alt: "access-denied-img",
    style: style
  });
};

var _default = AccessDenied;
exports.default = _default;